/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { AnimaBaixo2 } from '../../../../../../_metronic/assets/animation/styles'
import { FormCloudAdd } from '../../components/AddCloud/FormCloudAdd'

const AddCloudCategory: FC = () => {
  // const intl = useIntl()
  return (
    <>
      <AnimaBaixo2>
        <br />
        <FormCloudAdd />
      </AnimaBaixo2>
    </>
  )
}

export { AddCloudCategory }
